export const updateGameFromServer = (gameFen, moveSan) => ({
    type: "UPDATE_GAME",
    payload: { gameFen, moveSan },
});

export const placeBomb = (square) => ({
    type: "PLACE_BOMB",
    payload: square,
});

export const detonateBomb = (square) => ({
    type: "DETONATE_BOMB",
    payload: square,
});

export const setGameFen = (fen) => ({
    type: "SET_GAME_FEN",
    payload: fen,
});

export const setGameState = (gameState) => ({
    type: "SET_GAME_STATE",
    payload: gameState,
});

export const setPlayerInfo = (player) => ({
    type: "SET_PLAYER_INFO",
    payload: player,
});

export const setOpponentInfo = (opponent) => ({
    type: "SET_OPPONENT_INFO",
    payload: opponent,
});

export const setOrientation = (isWhite) => ({
    type: "SET_ORIENTATION",
    payload: isWhite,
});

export const setPlacingBombSeconds = (secs) => ({
    type: "SET_PLACING_BOMBS_SECONDS",
    payload: { secs, syncedAt: Date.now() },
});

export const setRandomizedBombs = ({ whitePlayerBombs, blackPlayerBombs }) => ({
    type: "SET_RANDOMIZED_BOMBS",
    payload: { whitePlayerBombs, blackPlayerBombs },
});

export const setMyBombs = (bombs) => ({
    type: "SET_MY_BOMBS",
    payload: bombs,
});

export const setTimers = ({ whiteTimeLeft, blackTimeLeft }) => ({
    type: "SET_TIMERS",
    payload: { whiteTimeLeft, blackTimeLeft, syncedAt: Date.now() },
});

export const logIn = (username) => ({
    type: "LOG_IN",
    payload: username,
});

export const logOut = () => {
    localStorage.removeItem('guestPlayerId'); // clear stale guest session on any logout path
    return { type: "LOG_OUT" };
};

export const playAsGuest = (guestID) => ({
    type: "PLAY_AS_GUEST",
    payload: guestID,
});

export const setMoveHistory = (moveHistory) => ({
    type: "SET_MOVE_HISTORY",
    payload: moveHistory,
});

export const resetGame = () => ({
    type: "RESET_GAME",
});

export const updatePlayerRating = (newRating) => ({
    type: "UPDATE_PLAYER_RATING",
    payload: newRating,
});

export const updateOpponentBombs = (bombs) => ({
    type: "UPDATE_OPPONENT_BOMBS",
    payload: bombs,
});

export const setIsAuthLoading = (isAuthLoading) => ({
    type: "SET_IS_AUTH_LOADING",
    payload: isAuthLoading,
});

export const setUserRole = (role) => ({
    type: "SET_USER_ROLE",
    payload: role,
});
